import React from 'react'

export default function Header(props) {


    return (
        <header className={`${props.theme == "dark" ? 'bg-gray-800 body-font text-gray-400' : "bg-gray-100"} body-font`}>
            <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
                <a className="flex title-font font-medium items-center mb-4 md:mb-0">
                    <span className="ml-3 text-xl">ToDo List</span>
                </a>
                <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
                    <a className={`mr-5 ${props.theme === "dark" ? 'hover:text-white' : "hover:text-gray-400"}`}>First Link</a>
                    <a className={`mr-5 ${props.theme === "dark" ? 'hover:text-white' : "hover:text-gray-400"}`}>Second Link</a>
                    <a className={`mr-5 ${props.theme === "dark" ? 'hover:text-white' : "hover:text-gray-400"}`}>Third Link</a>
                    <a className={`mr-5 ${props.theme === "dark" ? 'hover:text-white' : "hover:text-gray-400"}`}>Fourth Link</a>
                </nav>
                <div>
                    <button onClick={props.onevent} className={`inline-flex items-center  border-0 py-1 px-3 focus:outline-none   rounded text-base mt-4 md:mt-0 ${props.theme == "dark" ? "bg-gray-700 hover:bg-gray-600" : "bg-gray-200 hover:bg-gray-100"}`}>{props.theme == "dark" ? "Light" : "Dark"}
                    </button>
                </div>
            </div>
        </header>

    )
}
